import { FC, ReactNode } from "react";

import { Row, Text, TextProps } from "@hightouch/htui";

export const MetadataBar: FC<Readonly<{ children: ReactNode }>> = ({
  children,
}) => {
  return (
    <Row
      gap={8}
      mb={4}
      mt={2}
      flexShrink={0}
      sx={{
        "& > div": {
          ":not(:last-of-type)": {
            borderRightWidth: "hairline",
            borderRightStyle: "solid",
            pr: 8,
            borderColor: "base.divider",
          },
          minHeight: "40px",
          justifyContent: "space-between",
          whiteSpace: "nowrap",
        },
      }}
    >
      {children}
    </Row>
  );
};

export const MetadataLabel: FC<
  Readonly<{ children: ReactNode } & TextProps>
> = ({ children, ...props }) => {
  return (
    <Text {...props} fontWeight="semibold" size="sm" color="text.secondary">
      {children}
    </Text>
  );
};
